import React from "react";
import Slider from "react-slick";
import "../styles/Recipe.css";
import rec1 from "../assets/images/rec1.webp"
import rec3 from "../assets/images/rec3.webp"
import rec4 from "../assets/images/rec4.webp"
import rec5 from "../assets/images/rec5.webp"
import rec6 from "../assets/images/rec6.webp"


const RecipeSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerpadding: 0,
        autoplay: true,
        autoplaySpeed: 1400,
        rtl: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="reviews-section-recipe">
            <div className="">
                <h2 className="section-title-test">Delicious recipes
                </h2>
                <h5 className="px-2">Elevate every bite with Haronics oils: crafted for purity, rich flavor, and natural goodness that enhances every meal.</h5>
                <div className="google-reviews-container">
                    <Slider {...settings} className="reviews-slider">
                        {/* Review 1 */}
                        <div
                            className="review-card"
                        >
                            <div className="review-header">
                                <img src={rec1} alt="Sarah Johnson" className="reviewer-img" />
                            </div>

                        </div>

                        <div
                            className="review-card"
                        >
                            <div className="review-header">
                                <img src={rec3} alt="Sarah Johnson" className="reviewer-img" />
                            </div>

                        </div>
                        <div
                            className="review-card"
                        >
                            <div className="review-header">
                                <img src={rec4} alt="Sarah Johnson" className="reviewer-img" />
                            </div>

                        </div>
                        <div
                            className="review-card"
                        >
                            <div className="review-header">
                                <img src={rec5} alt="Sarah Johnson" className="reviewer-img" />
                            </div>

                        </div>
                        <div
                            className="review-card"
                        >
                            <div className="review-header">
                                <img src={rec6} alt="Sarah Johnson" className="reviewer-img" />
                            </div>

                        </div>
                    </Slider>
                </div>

            </div>
        </section>
    );
};

export default RecipeSection;

